module.exports = __webpack_public_path__ + "img/1.ff20e435.png";